// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__kOcI8","container":"styles_container__j5QyU","title":"styles_title__-jGDZ","image":"styles_image__Qiy5n"};